"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/PHFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_183)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_183`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 0.000244141H36V23.9998H0V0.000244141Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M36 0.000244141V12H18L0 0.000244141H36Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M36 12V23.9998H0L18 12H36Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.3841 12.0001L9.46538 11.0976L10.4872 9.23937L8.40366 9.6379L8.13964 7.53324L6.68839 9.08117L5.23721 7.53324L4.97318 9.6379L2.88975 9.2393L3.91146 11.0975L1.99277 12.0001L3.91146 12.9025L2.88975 14.7607L4.97332 14.3622L5.23721 16.4669L6.68839 14.9189L8.13964 16.4669L8.40366 14.3622L10.4871 14.7608L9.46531 12.9027L11.3841 12.0001ZM1.53195 2.26929L2.17045 3.16197L3.21664 2.83052L2.56498 3.71365L3.20349 4.6062L2.16223 4.25941L1.51057 5.14247L1.5188 4.04503L0.477539 3.69811L1.52379 3.3668L1.53195 2.26929ZM1.53195 18.8576L2.17045 19.7503L3.21664 19.4189L2.56498 20.302L3.20349 21.1946L2.16223 20.8478L1.51057 21.7308L1.5188 20.6334L0.477539 20.2865L1.52379 19.9551L1.53195 18.8576ZM14.7933 10.5635L14.1548 11.4561L13.1086 11.1247L13.7603 12.0078L13.1218 12.9005L14.163 12.5536L14.8147 13.4366L14.8065 12.3392L15.8477 11.9923L14.8015 11.6609L14.7933 10.5635Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_183`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as PHFlag };
